
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"51","height":"51","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.945 24.25c0-7.778 6.305-14.083 14.083-14.083h2.5c7.778 0 14.083 6.305 14.083 14.083v2.5c0 7.778-6.305 14.083-14.083 14.083h-2.5c-7.778 0-14.083-6.305-14.083-14.083v-2.5z","fill":"url(#paint0_linear)"}}),_c('path',{attrs:{"d":"M41.298 25.078a.5.5 0 010 .847l-13.56 8.514a.5.5 0 01-.766-.424V16.988a.5.5 0 01.766-.424l13.56 8.514zM22.861 21.944H10.39a.444.444 0 100 .89H22.86a.444.444 0 100-.89z","fill":"#EDEEFF"}}),_c('path',{attrs:{"d":"M15.25 25.972H2.778a.444.444 0 000 .89H15.25a.444.444 0 100-.89z","fill":"#F4B9FF"}}),_c('path',{attrs:{"d":"M22.861 30H10.39a.444.444 0 100 .889H22.86a.444.444 0 100-.889z","fill":"#EDEEFF"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear","x1":"48.611","y1":"25.5","x2":"17.945","y2":"25.5","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#F9BAFF"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#B9A9FF"}})])])])
          )
        }
      }
    